import React, { useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./margarita.css";

function Margarita() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <div className="accordion">
        <div className="accordion-item">
          <div className="accordion-header" onClick={() => toggleAccordion(0)}>
            <h3>
              Margarita
              <i
                className={`fas ${
                  activeIndex === 0 ? "fa-chevron-up" : "fa-chevron-down"
                }`}
                style={{ marginLeft: "10px" }}
              ></i>
            </h3>
          </div>
          <div className={`accordion-content ${activeIndex === 0 ? "open" : ""}`}>
            <h4>Ingredients</h4>
            <ul>
              <li>1ltr concentrate</li>
              <li>3.5ltr water</li>
              <li>500ml white spirit</li>
            </ul>
          </div>
        </div>

        <div className="accordion-item">
          <div className="accordion-header" onClick={() => toggleAccordion(1)}>
            <h3>
              Strawberry Daiquiri
              <i
                className={`fas ${
                  activeIndex === 1 ? "fa-chevron-up" : "fa-chevron-down"
                }`}
                style={{ marginLeft: "10px" }}
              ></i>
            </h3>
          </div>
          <div className={`accordion-content ${activeIndex === 1 ? "open" : ""}`}>
            <h4>Ingredients</h4>
            <ul>
              <li>1ltr concentrate</li>
              <li>3.5ltr water</li>
              <li>500ml white spirit</li>
            </ul>
          </div>
        </div>

        <div className="accordion-item">
          <div className="accordion-header" onClick={() => toggleAccordion(2)}>
            <h3>
              Feijoa Daiquiri
              <i
                className={`fas ${
                  activeIndex === 2 ? "fa-chevron-up" : "fa-chevron-down"
                }`}
                style={{ marginLeft: "10px" }}
              ></i>
            </h3>
          </div>
          <div className={`accordion-content ${activeIndex === 2 ? "open" : ""}`}>
            <h4>Ingredients</h4>
            <ul>
              <li>1ltr concentrate</li>
              <li>3.5ltr water</li>
              <li>500ml white spirit</li>
            </ul>
          </div>
        </div>

        <div className="accordion-item">
          <div className="accordion-header" onClick={() => toggleAccordion(3)}>
            <h3>
              Piña Colada
              <i
                className={`fas ${
                  activeIndex === 3 ? "fa-chevron-up" : "fa-chevron-down"
                }`}
                style={{ marginLeft: "10px" }}
              ></i>
            </h3>
          </div>
          <div className={`accordion-content ${activeIndex === 3 ? "open" : ""}`}>
            <h4>Ingredients</h4>
            <ul>
              <li>1ltr concentrate</li>
              <li>3.5ltr water</li>
              <li>500ml white spirit</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Margarita;